import React from 'react';
import './CtaContactSection.css';

const PhoneIcon = () => (
  <svg className="cta-contact-btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

const EmailIcon = () => (
  <svg className="cta-contact-btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

export default function CtaContactSection({ index, ctaContactSection }) {
  const section = ctaContactSection;

  if (!section) return null;

  return (
    <section id={'ctaContact' + index} className="cta-contact-section">
      <div className="cta-contact-inner">
        <div className="cta-contact-header">
          {section.heading && (
            <h2
              className="cta-contact-heading"
              dangerouslySetInnerHTML={{ __html: section.heading }}
            />
          )}
          {section.subtext && (
            <p
              className="cta-contact-subtext"
              dangerouslySetInnerHTML={{ __html: section.subtext }}
            />
          )}
        </div>
        <div className="cta-contact-buttons">
          {section.callUsLink && (
            <a href={section.callUsLink} className="cta-contact-btn">
              <PhoneIcon />
              <span>Call Us</span>
            </a>
          )}
          {section.emailUsLink && (
            <a href={section.emailUsLink} className="cta-contact-btn">
              <EmailIcon />
              <span>Email Us</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
